/**
 * Подложка на холсте: фото или скан плана квартиры в самом низу, под комнатами и стенами.
 *
 * Картинка растянута на свой прямоугольник плана (угол `x`, `y`, масштаб `mmPerPixel`) и
 * приглушена прозрачностью слоя. Мышь сквозь неё проходит — по подложке чертят, а не кликают.
 * В режиме сдвига она обведена пунктиром, чтобы было видно, что едет. На лист PDF не идёт.
 */
import type { UnderlayLayer } from "@/shared/plan";

const MOVE_COLOR = "#2f6feb";

interface Props {
	underlay: UnderlayLayer;
	/** Включён сдвиг подложки — обводим её */
	moving: boolean;
	mmPerPx: number;
}

export const UnderlayLayer2D = ({ underlay, moving, mmPerPx }: Props) => {
	const { image } = underlay;
	if (!image || !underlay.visible) return null;
	const width = image.width * underlay.mmPerPixel;
	const height = image.height * underlay.mmPerPixel;
	return (
		<g data-plan-export-exclude style={{ pointerEvents: "none" }}>
			<image
				href={image.src}
				x={underlay.x}
				y={underlay.y}
				width={width}
				height={height}
				opacity={underlay.opacity}
				preserveAspectRatio="none"
			/>
			{moving && (
				<rect
					x={underlay.x}
					y={underlay.y}
					width={width}
					height={height}
					fill="none"
					stroke={MOVE_COLOR}
					strokeWidth={1.5 * mmPerPx}
					strokeDasharray={`${6 * mmPerPx} ${4 * mmPerPx}`}
				/>
			)}
		</g>
	);
};
